import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Service Worker is registered via index.html with cache-purge logic
// Do NOT double-register here

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />,
);
